import React, { useEffect, useState, useRef } from "react";
import "../css/Login.css";
import logo from "../image/ClearVault_logo.png";
import sideImage from "../image/logincvault.png";
import { Formik, Field, Form, ErrorMessage } from "formik";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Button } from "@mui/material";

function Login() {
  const [data, setData] = useState({ Email: "", PassWord: "" });
  const [required, setRequired] = useState(false);
  const [incorrect, setIncorrect] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // checkUserData();
  }, []);

  useEffect(() => {
    const checkUserDatas = () => {
      if (window.location.pathname === "/login") {
        const userdata = JSON.parse(localStorage.getItem("userData"));

        if (!userdata) {
          // window.location.href = "/login";
        } else {
          checkUserData();
        }
      }
    };

    // Run on component mount
    checkUserDatas();

    const interval = setInterval(checkUserDatas, 500);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const handleData = (e) => {
    var value = e.target.value;
    var name = e.target.name;
    setRequired(false);
    setIncorrect(false);
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleKeyPressUser = (event) => {
    if (event.key === "Enter") {
      passwordRef.current.focus();
    }
  };
  const handleKeyPressPass = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const redirectFunction = () => {
    const userdata = JSON.parse(localStorage.getItem("userData"));
    // userdata.role = 'Inspector'
    if (userdata?.role === "Admin") {
      window.location.href = "/admin";
    } else if (userdata?.role === "Owner") {
      window.location.href = "/owner";
    } else if (userdata?.role === "Contractor") {
      window.location.href = "/contractor";
    } else if (userdata?.role === "Inspector") {
      window.location.href = "/inspector";
    }
  };

  const checkUserData = () => {
    if (window.location.pathname == "/login") {
      const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
        const [name, value] = cookie.split("=");
        acc[name] = decodeURIComponent(value);
        return acc;
      }, {});
      var userdata = JSON.parse(localStorage.getItem("userData"));
      const isLogin = Boolean(cookies.sessionid);
      const isLoginAsSessionStorage = Boolean(localStorage.getItem("userData"));
      // alert(JSON.stringify(userdata))

      if (userdata?.role && isLogin && isLoginAsSessionStorage) {
        if (userdata?.role == "Admin") {
          window.location.href = "/admin";
        } else if (userdata?.role == "Owner") {
          window.location.href = "/owner";
        } else if (userdata?.role == "Contractor") {
          window.location.href = "/contractor";
        } else if (userdata?.role == "Inspector") {
          window.location.href = "/inspector";
        }
      }
    }
  };

  const handleLogin = async () => {
    var Email = data.Email;
    var Password = data.PassWord;
    if (Email && Password) {
      try {
        var datas = await axios.post(`/cvault/login`, {
          email: Email,
          password: Password,
        });
        // // localStorage.removeItem('userData');
        localStorage.setItem("userData", JSON.stringify(datas.data));
        // window.location.href = "/";
        redirectFunction();
      } catch (error) {
        setIncorrect(true);
      }
    } else {
      setRequired(true);
    }
  };

  useEffect(() => {
    // Focus on the email input when the component mounts
    usernameRef.current.focus();
  }, []);

  return (
    <div className="card card0 border-0 h-100">
      <div className="row d-flex">
        <div className="col-lg-6">
          <div className="card1 pb-5">
            <div className="row px-3 justify-content-center mt-5 mb-5 border-line">
              <img src={sideImage} className="image" />
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="card2 card border-0 px-4 py-4"
            style={{ margin: "0rem 8rem" }}
          >
            <div className="d-flex justify-content-center mb-3">
              <img src={logo} className="logo" />
            </div>
            <div className="row px-3">
              {" "}
              <label className="mb-1 ps-0">
                <h6 className="mb-0 text-sm">Email Address</h6>
              </label>{" "}
              <input
                ref={usernameRef}
                onKeyPress={handleKeyPressUser}
                className="mb-4"
                type="text"
                value={data.Email}
                onInput={(event) => {
                  handleData(event);
                }}
                name="Email"
                placeholder="Enter a valid email address"
                maxLength={250}
              />{" "}
            </div>
            <div className="row px-3">
              {" "}
              <label className="mb-1 ps-0">
                <h6 className="mb-0 text-sm">Password</h6>
              </label>{" "}
              <div className="p-0" style={{ position: "relative" }}>
                <input
                  ref={passwordRef}
                  onKeyPress={handleKeyPressPass}
                  type={showPassword ? "text" : "password"}
                  name="PassWord"
                  value={data.PassWord}
                  onInput={(event) => handleData(event)}
                  placeholder="Enter password"
                  maxLength={250}
                  style={{ paddingRight: "40px" }} // space for the eye icon
                />

                {/* Eye toggle button */}
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "40%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              {required ? (
                <p className="ms-2" style={{ color: "red" }}>
                  Email and Password is required
                </p>
              ) : (
                <p />
              )}
              <p
                className="d-flex justify-content-end me-2"
                style={{
                  // textDecoration: "underline",
                  color: "#1A237E",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/forgot-password")}
              >
                Forgot Password?
              </p>
            </div>
            {incorrect ? (
              <p style={{ color: "red", marginTop: "10px" }}>
                Email or Password is incorrect
              </p>
            ) : null}

            {/* <div className="d-flex justify-content-start mb-4"> */}
            {/* <a href="#" className="ms-auto mb-0 mt-2 text-sm">
                Forgot Password?
              </a> */}
            {/* </div> */}
            <div className="row mb-3 px-3">
              {" "}
              <Button
                type="submit"
                onClick={handleLogin}
                fullWidth
                variant="contained"
                sx={{
                  marginTop: "5px", // Reduced margin
                  backgroundColor: "#1A237E",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#0D1B64", // Custom hover color
                  },
                }}
                style={{ borderRadius: "4px" }}
              >
                Login
              </Button>{" "}
            </div>
            <div className="row mb-4 px-1">
              {" "}
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/register")}
              >
                <span>Don't have an account? </span>
                <span className="ms-1" style={{ color: "#1A237E" }}>
                  Register
                </span>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
      <footer className="footer mt-auto bg-blue py-3">
        <div className="row px-3">
          {" "}
          <small className="ml-4 ml-sm-5 mb-2">
            Copyright &copy; 2025. All rights reserved.
          </small>
        </div>
      </footer>
      {/* <footer className="footer mt-auto py-3 bg-light">
                <div className="container">
                    <span className="text-muted">Place sticky footer content here.</span>
                </div>
            </footer> */}
    </div>
  );
}

export default Login;
